<template>
    <div>
        <v-custom-select v-model="selectedAddress"
                         :options="CustomerAddressOptions"
                         option-name="Header"
                         option-value="Name"
                         search-label="Header"
                         name="addres-select"
                         :fluid="true"
                         :multiple="false"
                         @change="setAddress"
                         :readOnly="readOnly"
                         :error="localError">

            <slot slot="label"><slot name="label"></slot></slot>
            <slot slot="action">
                <v-add-address v-if="!readOnly" @addressAdded="addNewAddress" :customerKey="customerKey"></v-add-address>
            </slot>
            <div class="c-selected-address" slot="suffix" v-if="hasAddress && selectedAddress.Street">
                <div>{{ selectedAddress.Name  }}</div>
                <div>{{ selectedAddress.Street }} {{ selectedAddress.HouseNumber }}</div>
                <div>{{ selectedAddress.ZipCode  }} {{ selectedAddress.City }}</div>
                <div>{{ selectedAddress.CountryName  }}</div>
                <template v-if="showContactEmail || showContactPhone">
                    <br/>
                    <div v-if="selectedAddress.Phone || selectedAddress.Email">{{ $t('global.contact') }}:</div>
                    <div v-if="showContactPhone">{{ selectedAddress.Phone }}</div>
                    <div v-if="showContactEmail">{{ selectedAddress.Email }}</div>
                </template>
            </div>
        </v-custom-select>

        <v-error v-if="localError">
            <slot name="error">{{ localError }}</slot>
        </v-error>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VSelectedAddress from '@/components/form/addressSelect/SelectedAddress'
    import VAddAddress from '@/components/form/addressSelect/AddAddress'
    import VError from './../Error.vue'
    import _some from 'lodash/some'
    import _isEmpty from 'lodash/isEmpty'

    // Store
    import {mapState} from 'vuex'
    import {mapGetters} from 'vuex'

    export default {
        props: {
            error: String,
            addAddress: { type: Boolean, default: true },
            customerKey: { type: Number, required: true },
            showContactEmail: { type: Boolean, default: false },
            showContactPhone: { type: Boolean, default: false },
            value: Object,
            readOnly: { type: Boolean, default: false }
        },
        components: {
            VCustomSelect,
            VSelectedAddress,
            VAddAddress,
            VError
        },
        data() {
            return {
                localError: this.error
            }
        },
        created() {
            this.fetchData();
        },
        computed: {
            CustomerAddressOptions() {
                return this.$store.getters.CustomerAddressOptions
            },
            selectedAddress: {
                get() {
                    return this.value;
                },
                set(value) {
                    return value.Name;
                }
            },
            hasAddress() {
                return !_isEmpty(this.value);
            }
        },
        watch: {
            customerKey() {
                this.fetchData();
            },
            error() {
                this.localError = this.error;
            }
        },
        methods: {
            setAddress(value) {
                this.$emit('input', value);
            },
            addNewAddress(newAddress) {
                this.CustomerAddressOptions.push(newAddress);
                this.setAddress(newAddress);
            },
            fetchData() {
                this.$store.dispatch('getCustomerAddressOptions', this.customerKey)
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-selected-address {
        border: 1px solid palette(color-neutral, medium);
        padding: em($global-spacing-unit-tiny);
        margin-top: em($global-spacing-unit-small);
        margin-bottom: em($global-spacing-unit-small);
    }

</style>



// WEBPACK FOOTER //
// src/components/form/addressSelect/AddressSelect.vue